import { ChangeDetectorRef, Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import * as moment from 'moment';
import { AlertService } from '../_services/alert.service';

@Component({
    selector: 'app-input-cell-editor',
    template: `
    <div class="custom-renderer-ag">
         <input type="datetime-local" class="form-control form-ctrl" style="border-bottom: inherit !important;" [min]="minDateTime" [disabled]="params.node.data.isDatepickerDisabled" [(ngModel)]="selectedValue" (change)="onValueChange($event)">
</div>
  `,
})
export class DatepickerCellRenderer implements ICellEditorAngularComp {
    params: any;
    public selectedValue: any;
    public minDateTime: string;
    constructor(private alertService : AlertService){

    }

    agInit(params: any): void {
        this.minDateTime = moment().format('YYYY-MM-DDTHH:mm');
        this.params = params;
        this.selectedValue = moment(params.value, ['MM-DD-YYYYTHH:mm']).format('YYYY-MM-DDTHH:mm');
    }

    refresh(params: any) {
        this.params = params;
        return true;
    }

    getValue(): any {
        return this.selectedValue;
    }

    isPopup(): boolean {
        return true; // Return true if you want popup editing style
    }

    // Optional methods
    // You can add additional methods like focusIn, focusOut, etc. as needed

    onValueChange(newValue: any): void {
        const selectedDate = new Date(newValue.target.value);
        const currentDate = new Date();
        if (selectedDate < currentDate) {
            this.selectedValue = moment(this.params.value, ['MM-DD-YYYYTHH:mm']).format('YYYY-MM-DDTHH:mm');
            this.alertService.errorAlertWithMessage('Please select a date and time not earlier than the current date and time.');
            newValue.preventDefault(); // Prevent form submission or do any other validation handling
            return;
        }
        this.params.setValue(newValue.target.value);
        // this.params.api.stopEditing();
    }

    // Implement other necessary methods from ICellEditorAngularComp interface
}
